import React from 'react'
import "./css/common.css"

export default function ExtrapolationTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        EXTRAPOLATION
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
